import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepTitle } from 'embed/components/Application/StepTitle'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepPhone: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What’s your phone number?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.PhoneNumber} onEnter={props.onEnter} />
  </Wrapper>
)

export default StepbystepApplicationStepPhone
